import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import TargetComp from './TargetComp'

function Targets() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <TargetComp/>      
        </div>
    </div>
  )
}

export default Targets